// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__24n2d","header":"MessagesList_header__p-P-t","chat":"MessagesList_chat__jfHk-"};